import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'personal', 'exam', 'files', 'payment', 'quitus', 'currentStep', 'schoolField', 'candidateType', 'scholarityField' ];

  connect() {
    // Sans sélecteur de type (utilisateur « école » : candidat toujours officiel,
    // établissement lié automatiquement), les champs restent tels que rendus.
    if (this.hasCandidateTypeTarget) {
      this._syncOfficialFields(this.candidateTypeTarget.value);
    } else if (this.hasSchoolFieldTarget) {
      this.schoolFieldTarget.classList.add('d-none');
    }
  }

  displayPreviousStep(e) {
    e.preventDefault();
    const step = e.target.dataset['step'];
    this._hideAllSteps();
    this._updateCurrentStep();
    this[`${step}Target`].classList.remove('d-none');
  }

  // Action du sélecteur « Type de candidat » (nom conservé pour les autres formulaires).
  toggleSchoolField(e) {
    this._syncOfficialFields(e.target.value);
  }

  // L'établissement et le certificat de scolarité ne concernent que les candidats officiels.
  _syncOfficialFields(candidateType) {
    const official = candidateType == 'official_candidate';

    if (this.hasSchoolFieldTarget) {
      this.schoolFieldTarget.classList.toggle('d-none', !official);
    }

    if (this.hasScholarityFieldTarget) {
      this.scholarityFieldTarget.classList.toggle('d-none', !official);
      // Un champ désactivé n'est ni envoyé ni téléversé (direct upload).
      this.scholarityFieldTarget.querySelectorAll('input').forEach(input => { input.disabled = !official; });
    }
  }

  _hideAllSteps() {
    Array.from(document.querySelectorAll('.inscription-step')).forEach(elt => elt.classList.add('d-none'));
  }

  _updateCurrentStep() {
    const value = this[`currentStepTarget`].value;
    this[`currentStepTarget`].value = parseInt(value) - 1;
  }
}
